import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import AppSidebar from '../components/AppSidebar';
import { PricingCard } from '../components/PricingCard';

const Upgrade = () => {
  const { t } = useApp();
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="flex bg-background" data-testid="upgrade-page">
      <AppSidebar conversations={[]} onNewChat={() => navigate('/chat')} />
      <main className="flex-1 h-screen overflow-y-auto min-w-0">
        <div className="h-16 border-b border-border flex items-center px-5 sm:px-8 sticky top-0 bg-background/80 backdrop-blur z-10">
          <h1 className="font-display text-xl font-bold">{t.pricing.upgradeTitle}</h1>
        </div>
        <div className="max-w-md mx-auto px-5 py-12">
          <div className="text-center mb-10">
            <span className="h-12 w-12 mx-auto rounded-2xl bg-primary/10 text-primary flex items-center justify-center"><Zap className="h-6 w-6" /></span>
            <h2 className="mt-4 font-display text-3xl font-bold">{t.pricing.title}</h2>
            <p className="mt-2 text-muted-foreground">{t.pricing.subtitle}</p>
            {user && user.plan !== 'pro' && <p className="mt-3 text-sm text-muted-foreground" data-testid="usage-info">{t.account.usage.replace('{used}', user.usage_today ?? 0).replace('{limit}', user.free_daily_limit)}</p>}
          </div>
          <PricingCard />
        </div>
      </main>
    </div>
  );
};

export default Upgrade;
